<template>
  <div class="crm-comments">
    <h5 class="title text-uppercase" style="font-size: 12px;">Commentaires</h5>
    <textarea
      class="form-control mb-2"
      rows="3"
      placeholder="Ex. Il manque le relevé d'informations, rappeler après 16h…"
      v-model="draftLocal"
      @input="$emit('update:draft', draftLocal)"
    ></textarea>
    <button class="btn btn-market btn-sm mb-3" :disabled="!draftLocal.trim() || saving" @click="$emit('add')">
      Ajouter le commentaire
    </button>
    <p v-if="!comments || !comments.length" class="text-muted small mb-0">Aucun commentaire</p>
    <ul v-else class="list-unstyled mb-0">
      <li
        v-for="(c, i) in commentsSorted"
        :key="c.id || i"
        class="border-bottom border-secondary pb-2 mb-2"
      >
        <p class="text-muted small mb-1">{{ c.created_at }} — {{ c.created_by || '—' }}</p>
        <p class="mb-0">{{ c.body }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CommentsBlock',
  props: {
    comments: { type: Array, default: () => [] },
    draft: { type: String, default: '' },
    saving: { type: Boolean, default: false }
  },
  data() {
    return { draftLocal: this.draft }
  },
  watch: {
    draft(v) {
      this.draftLocal = v
    }
  },
  computed: {
    commentsSorted() {
      return [...(this.comments || [])].reverse()
    }
  }
}
</script>
